<template>
    <div class="inline-block">
        <button
            class="btn-icon"
            @click="$modal.show(containerId)"
        >
            <slot>
                <font-awesome-icon
                    icon="home"
                />
            </slot>
        </button>

        <adaptive-modal
            :name="containerId"
            :hide-action-buttons="true"
            width="800"
            @before-open="beforeOpen"
        >
            <div :id="containerId" />
            <button
                type="button"
                class="btn is-ghost btn-lg mt-2xl"
                @click="hide"
            >
                Stäng
            </button>
        </adaptive-modal>
    </div>
</template>
<script>
    export default {
        props: {
            fieldName: {
                type: String,
                required: true,
            },
            fieldValue: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
            };
        },

        computed: {
            containerId() {
                return 'address-query-result-container-' + this.fieldName;
            },
        },

        methods: {
            beforeOpen(event) {
                var containerId = this.containerId;
                var iframe = document.createElement('iframe');

                iframe.setAttribute('src', route('admin.addressQuery', { 'fieldName': this.fieldName, 'fieldValue': this.fieldValue }));
                iframe.setAttribute('style', 'height: 75%; width: 100%;');

                setTimeout(function () {
                    document.querySelector('#' + containerId).append(iframe);
                }, 10);
            },
            hide() {
                this.$modal.hide(this.containerId);
            },
        },
    };
</script>
